<crud-list class="col-12" [data]="table" [detailUrl]="'/enaio-certificates/class-registers/course/' + year + '/'" restUrl="api/cer/classregister/course">
    <ng-template #toolbarTemplate>
        <p-checkbox label="Ausgelaufene Kurse anzeigen" class="ml-3 option" name="showFinishedCourses" [(ngModel)]="showFinishedCourses" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>        
    </ng-template> 
</crud-list>
